import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["className"];

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import HelpIcon from '@mui/icons-material/Help';
import { Link, styled, tooltipClasses, Typography } from '@mui/material';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { Tooltip } from '../../../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledTooltip = styled( /*#__PURE__*/forwardRef(function StyledTooltip(_ref, ref) {
  var _props$classes;

  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, props), {}, {
    classes: _objectSpread(_objectSpread({}, props.classes), {}, {
      popper: clsx((_props$classes = props.classes) === null || _props$classes === void 0 ? void 0 : _props$classes.popper, className)
    }),
    ref: ref
  }));
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & .", " {\n    background-color: ", ";\n    padding: ", ";\n    max-width: 300px;\n    color: ", ";\n    box-shadow: ", ";\n  }\n"])), tooltipClasses.tooltip, function (p) {
  return p.theme.palette.common.white;
}, function (p) {
  return p.theme.spacing(1);
}, function (p) {
  return p.theme.palette.common.black;
}, function (p) {
  return p.theme.shadows[4];
});

var ActiveTooltip = function ActiveTooltip() {
  return /*#__PURE__*/_jsx(StyledTooltip, {
    title: /*#__PURE__*/_jsxs(TooltipModal, {
      children: ["This is a copied view of your member as of the time the Lens was loaded. Anything you do in this mode will not affect the member's account, and their challenges, points, etc., will remain untouched.", /*#__PURE__*/_jsx(MoreInfoLink, {
        children: "Learn More"
      })]
    }),
    "data-element": "StyledTooltip",
    "data-component": "ActiveTooltip",
    "data-source-file": "active-tooltip.tsx",
    children: /*#__PURE__*/_jsx(HelpIcon, {
      "aria-label": "more information",
      fontSize: "inherit",
      sx: {
        ml: 1,
        mb: 0.25
      },
      "data-element": "HelpIcon",
      "data-component": "ActiveTooltip",
      "data-source-file": "active-tooltip.tsx"
    })
  });
};

var TooltipModal = styled(Typography)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: ", ";\n  max-width: 300px;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.spacing(1);
}, function (p) {
  return p.theme.palette.common.white;
}, function (p) {
  return p.theme.palette.common.black;
});
var MoreInfoLink = styled(Link)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: underline;\n  &:hover {\n    text-decoration: none;\n  }\n"])), function (p) {
  return p.theme.palette.common.black;
});
export default ActiveTooltip;